import { makeStyles } from "@material-ui/core";
import { Typography, Box } from "@mui/material";
import { useState } from "react";
import { connect } from "react-redux";
import { Field, reduxForm, formValueSelector } from "redux-form";
import SubmitLoader from "src/components/SubmitLoader";
import {
  CancelButton,
  RdxAutocompleteField,
  RdxCheckBox,
  RdxTextField,
  SubmitButton,
} from "src/components/form/InputFields";
import { data } from "src/mock/address";
import { graph2 } from "src/mock/graph";
import {
  getTduUsage,
  setShowRateGraphInStore,
  setUsageInStore,
} from "src/slices/bkvReducer";
import { useSelector, useDispatch } from "src/store";
import * as yup from "yup";

const validationSchema = yup.object().shape({
  firstName: yup.string().max(40).nullable().required(),
  lastName: yup.string().max(40).nullable().required(),
  email: yup.string().email().nullable().required(),
  consent: yup.boolean().nullable().oneOf([true]).required(),
});

const validate = (values) => {
  const formErrors = {};

  try {
    validationSchema.validateSync(values, { abortEarly: false });
  } catch (errors) {
    errors.inner.forEach((error) => {
      formErrors[error.path] = error.message;
    });
  }

  return formErrors;
};

let TduForm = (props) => {
  const classes = useStyles();
  const state = useSelector((state) => state.bkv);
  const dispatch = useDispatch();
  const { handleSubmit, pristine, handleClose, changeView } = props;
  const [submitting, setSubmitting] = useState(false);
  const [firstName, setFirstName] = useState();
  const [lastName, setLastName] = useState();
  const [email, setEmail] = useState();

  const onSubmit = async (values) => {
    setSubmitting(true);
    dispatch(
      getTduUsage(values, () => {
        dispatch(setShowRateGraphInStore(false));
        setSubmitting(false);
        handleClose("usageModal");
      })
    );
  };

  const handleBack = () => {
    changeView("options");
  };

  const handleFormChange = (val) =>{
    if (val.name === 'email') {
      return setEmail(val.value);
    }else if (val.name === 'firstName') {
      return setFirstName(val.value);
    }else if (val.name === 'lastName') {
      return setLastName(val.value);
    }  
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)} onChange={(e)=>handleFormChange(e.target)}>
      <Box className={classes.root}>
        <Typography
          align="center"
          variant="body2"
          fontSize={{
            xs: "3.8vw",
            sm: "3.8vw",
            md: "3.3vw",
            lg: "25px",
          }}
        >
          We are almost there with your usage data
        </Typography>
        <Typography
          sx={{
            fontSize: {
              xs: "2.5vw",
              sm: "2.5vw",
              md: "2.5vw",
              lg: "1.3vw",
            },
            marginTop: "3%",
            color: "#595959",
          }}
          align="center"
        >
          You must grant us permission to your usage data by providing
          information below
        </Typography>
        <Field
          name="firstName"
          width={100}
          label="First Name"
          placeholder="Type your First Name"
          component={RdxTextField}
          style={{ background: "rgb(237 237 237)" }}
        />
        <Field
          name="lastName"
          width={100}
          label="Last Name"
          placeholder="Type your Last Name"
          component={RdxTextField}
          style={{ background: "rgb(237 237 237)" }}
        />
        <Field
          name="email"
          width={100}
          label="E-mail"
          placeholder="Type your E-mail"
          component={RdxTextField}
          style={{ background: "rgb(237 237 237)" }}
        />
        <Box className={classes.consents}>
          <Field name="consent" component={RdxCheckBox}>
            I authorize my utility company to grant BKV Energy access to the
            information as stated in the{" "}
            <a
              href="/static/files/Standard-Letter-of-Authorization-for-Request-of-Historical-Usage-Information-English-.pdf"
              target="_blank"
              rel="noreferrer"
              style={{ color: "#6288e9" }}
            >
              Letter of Authorization
            </a>
          </Field>
        </Box>
        <Box className={classes.buttonBox}>
          <CancelButton onClick={handleBack} disabled={submitting}>
            Back
          </CancelButton>
          <SubmitButton type="submit" disabled={!firstName || !lastName || !email || pristine || submitting}>
            Continue
          </SubmitButton>
        </Box>
        <SubmitLoader open={submitting} />
      </Box>
    </form>
  );
};

TduForm = reduxForm({
  form: "TduForm",
  validate,
  initialValues: {
    consent: false,
  },
})(TduForm);
const selector = formValueSelector("TduForm");
// TduForm = connect(state => {
//     const consent = selector(state, 'consent')
//     return {
//         consent
//     }
// })(TduForm)

export default TduForm;

const useStyles = makeStyles((theme) => ({
  root: {
    padding: "5% 5%",
    maxWidth: 757,
    backgroundColor: "#fff",
    [theme.breakpoints.down("sm")]: {
      padding: "5% 5%",
    },
  },
  consents: {
    marginTop: 18,
    marginBottom: "8%",
    display: "flex",
    flexDirection: "column",
    [theme.breakpoints.down("md")]: {
      marginTop: 18,
      marginBottom: "8%",
    },
  },
  buttonBox: {
    marginTop: 50,
    display: "flex",
    gap: 30,
    justifyContent: "space-between",
    alignItems: "center",
    [theme.breakpoints.down("md")]: {
      marginTop: 20,
    },
  },
}));
